import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router';
import { Box, Container } from '@mui/material';

import { CONSTANTS, STRINGS } from 'src/commons';
import { commonReducerAction } from 'src/redux/reducers/common';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { batchesReducerAction } from 'src/redux/reducers/batches';
import { deleteBatch, getBatch } from 'src/api/batches';
import BatchListResults from 'src/components/batches/BatchListResults';
import Toolbar from 'src/components/batches/Toolbar';

const Batches = () => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const [batches, setBatches] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, gymId } = useSelector((state) => state.common);
  const { batchList } = useSelector((state) => state.batches);
  const { updateBatches } = batchesReducerAction;
  const { logoutUser } = commonReducerAction;
  const [searchLoader, setSearchLoader] = useState(false);

  const getData = () => {
    dispatch(startLoading());
    getBatch(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN) logoutUser();
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          setBatches(res.data);
          dispatch(updateBatches(res.data));
        }
        dispatch(stopLoading());
      })
      .catch((err) => {
        dispatch(stopLoading());
        console.log(err);
      });
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onEdit = (item) => {
    navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.EDIT_BATCH + '/' + item._id);
  };
  const onDelete = (item) => {
    dispatch(startLoading());
    deleteBatch(user, item._id).then(() => {
      getData();
    }).catch(()=>{
      dispatch(stopLoading())
    });
  };

  const filterItem = (text) => {
    setSearchLoader(true);
    setBatches(
      batchList.filter((batch) =>
        batch.name?.toLowerCase()?.includes(text?.trim()?.toLowerCase())
      )
    );
    setSearchLoader(false);
  };

  return (
    <>
      <Helmet>
        <title>Batches | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            searchLoader={searchLoader}
            filterItem={filterItem}
            text={STRINGS.ADD_BATCH}
            route={CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_BATCH}
          />
          <Box sx={{ pt: 3 }}>
            <BatchListResults
              batches={batches}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Batches;
